import { useQuery } from '@tanstack/react-query';
import { fetchDepartmentsApi } from './helper';

export const useDepartmentsQuery = (organisationId?: string) => {
  return useQuery({
    queryKey: ['departments', organisationId],
    queryFn: () => fetchDepartmentsApi(organisationId!),
    enabled: !!organisationId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 1
  });
};
